const streams = [
    { id: '042', name: 'Estates', available: false },
    { id: '031', name: 'Finance', available: false },
    { id: '025', name: 'Staff', available: false },
    { id: '056', name: 'Student', available: true },
]

export const getAll = () => new Promise(resolve => resolve({ streams }))
